import React from 'react';
import { LocalizedContent } from '../../data/siteContent';
type Props = {
  content: LocalizedContent;
  progress: number;
  activeScene: number;
  sceneCount: number;
  onNavigate: (scene: number) => void;
};

// A quiet film-position cue that expands with the complete travel story.
export function JourneyProgress({
  content,
  progress,
  activeScene,
  sceneCount,
  onNavigate
}: Props) {
  return <div className="pointer-events-none fixed right-6 top-1/2 z-30 hidden -translate-y-1/2 lg:block" aria-label={content.journey.progressLabel} data-id="element-188" data-mp="3vcly289osqmk">
      <div className="relative flex flex-col gap-2" data-id="element-189" data-mp="3qdsk6eqhmxlv">
        <div className="absolute left-1/2 top-1 h-[calc(100%-0.5rem)] w-px -translate-x-1/2 bg-white/15" data-id="element-190" data-mp="8y2jaagsv9fk" />
        <div className="absolute left-1/2 top-1 w-px -translate-x-1/2 bg-[var(--ms-gold-soft)]" style={{
        height: `calc(${Math.min(progress * 100, 100)}% - 0.5rem)`
      }} data-id="element-191" data-mp="3y7t694umnvk" />
        {Array.from({
        length: sceneCount
      }, (_, index) => <button key={index} type="button" onClick={() => onNavigate(index)} aria-label={`${content.journey.progressLabel}: ${index + 1}`} className="pointer-events-auto relative flex h-2 w-2 items-center justify-center focus:outline-none" data-id="element-192" data-mp="cxbd1fbub7b4">
            <span className={`h-1.5 w-1.5 rounded-full transition-transform duration-300 ${index === activeScene ? 'scale-[1.7] bg-[var(--ms-gold-soft)]' : 'bg-white/55 hover:bg-white'}`} data-id="element-193" data-mp="rq1et1kd8htl" />
          </button>)}
      </div>
    </div>;
}